'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _elementResizeDetector = require('element-resize-detector');

var _elementResizeDetector2 = _interopRequireDefault(_elementResizeDetector);

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('./constants');

var _SizeStore = require('./SizeStore');

var _SizeStore2 = _interopRequireDefault(_SizeStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var makeReactiveContainer = function makeReactiveContainer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      defaultSize = _ref.defaultSize,
      minAdjustment = _ref.minAdjustment,
      throttleMS = _ref.throttleMS;

  return function (Container) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      _inherits(Reactive, _Component);

      function Reactive() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, Reactive);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Reactive.__proto__ || Object.getPrototypeOf(Reactive)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {}, _this.getSize = function (width, breakpoints) {
          var sortedBreakpoints = (0, _lodash.sortBy)(breakpoints, function (bp) {
            return bp.minWidth;
          });
          if (width < (0, _lodash.first)(sortedBreakpoints).minWidth) {
            return _this.props.defaultSize;
          }
          var largestBreakpoint = (0, _lodash.last)(sortedBreakpoints);
          if (width >= largestBreakpoint.minWidth) {
            return largestBreakpoint.name;
          }
          var idx = (0, _lodash.findLastIndex)(sortedBreakpoints, function (bp) {
            return width >= bp.minWidth;
          });
          var breakpoint = sortedBreakpoints[idx];
          return breakpoint.name;
        }, _this.setRef = function (element) {
          _this.element = element;
        }, _this.setWidth = function () {
          var _this$element$getBoun = _this.element.getBoundingClientRect(),
              width = _this$element$getBoun.width;

          var savedWidth = _this.state.width;
          if (width <= savedWidth - _this.props.minAdjustment || width >= savedWidth + _this.props.minAdjustment || !savedWidth) {
            _this.setState({ width: width });
            var size = _this.getSize(width, _this.props.breakpoints);
            _this.sizeStore.setSize(size);
          }
        }, _this.resizeEventHandler = function () {
          _this.setWidth();
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(Reactive, [{
        key: 'getChildContext',
        value: function getChildContext() {
          return {
            sizeStore: this.sizeStore
          };
        }
      }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.sizeStore = new _SizeStore2.default(this.props.defaultSize);
          this.elementResizeDetector = (0, _elementResizeDetector2.default)();
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.setWidth();
          this.elementResizeDetector.listenTo(this.element, (0, _lodash.throttle)(this.resizeEventHandler, this.props.throttleMS));
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.elementResizeDetector.removeAllListeners(this.element);
        }
      }, {
        key: 'render',
        value: function render() {
          var componentProps = (0, _lodash.omit)(this.props, ['breakpoints', 'defaultSize', 'minAdjustment', 'throttleMS']);

          return _react2.default.createElement(Container, _extends({
            innerRef: this.setRef,
            size: this.sizeStore.size
          }, componentProps));
        }
      }]);

      return Reactive;
    }(_react.Component), _class.childContextTypes = {
      sizeStore: _propTypes2.default.object.isRequired
    }, _class.displayName = 'Reactive(' + (Container.displayName || Container.name) + ')', _class.propTypes = {
      breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired,
        minWidth: _propTypes2.default.number.isRequired
      })).isRequired,
      defaultSize: _propTypes2.default.string.isRequired,
      minAdjustment: _propTypes2.default.number,
      throttleMS: _propTypes2.default.number
    }, _class.defaultProps = {
      defaultSize: defaultSize || _constants.DEFAULT_SIZE,
      minAdjustment: minAdjustment || _constants.DEFAULT_MIN_ADJUSTMENT,
      throttleMS: throttleMS || _constants.DEFAULT_THROTTLE_MS
    }, _temp2;
  };
};

exports.default = makeReactiveContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-container/dist/makeReactiveContainer.js
// module id = 1432
// module chunks = 2